define("calendar/components/calendar/onboarding/modals/trial-opt-in", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @close={{@closeTrialOptInModal}} as |modal|>
    <modal.card @portrait={{false}} class="tPF--modalCard tPF--modalCard__trial">
      <modal.card-header class="u--p__b__sm">
        <h2 class="tPF--plan__title u--text--center u--m__t">
          {{t "authorization.sign_up_trial.page_title"}}
        </h2>
        <p class="u--text--center u--text--light u--m__0">
          {{t "authorization.sign_up_trial.sub_title"}}
        </p>
      </modal.card-header>
      <modal.card-body class="u--p__t__0">
        <div class="tPF--plan tPF--plan—-sm">
          {{#each this.trialOptInPlans as |plan|}}
            <SeamlessCheckout::PlanCard
              @onPlanButtonClick={{fn this.handlePlanButtonClick plan.planType}}
              @plan={{plan}}
            />
          {{/each}}
        </div>
      </modal.card-body>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "3MQSwh8I",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],[[24,0,\"tPF--modalCard tPF--modalCard__trial\"]],[[\"@portrait\"],[false]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],[[24,0,\"u--p__b__sm\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"h2\"],[14,0,\"tPF--plan__title u--text--center u--m__t\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"authorization.sign_up_trial.page_title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--center u--text--light u--m__0\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"authorization.sign_up_trial.sub_title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"tPF--plan tPF--plan—-sm\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"trialOptInPlans\"]]],null]],null],null,[[[1,\"          \"],[8,[39,4],null,[[\"@onPlanButtonClick\",\"@plan\"],[[28,[37,5],[[30,0,[\"handlePlanButtonClick\"]],[30,3,[\"planType\"]]],null],[30,3]]],null],[1,\"\\n\"]],[3]],null],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@closeTrialOptInModal\",\"modal\",\"plan\"],false,[\"shared/modal\",\"t\",\"each\",\"-track-array\",\"seamless-checkout/plan-card\",\"fn\"]]",
    "moduleName": "calendar/components/calendar/onboarding/modals/trial-opt-in.hbs",
    "isStrictMode": false
  });
  let TrialOptInComponent = _exports.default = (_class = class TrialOptInComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "router", _descriptor, this);
      _initializerDefineProperty(this, "plans", _descriptor2, this);
      _initializerDefineProperty(this, "trialOptInPlans", _descriptor3, this);
      _defineProperty(this, "loadTrialPlans", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.trialOptInPlans = yield this.plans.trialOptInPlans();
        }
      }), null, "loadTrialPlans", null));
      this.loadTrialPlans.perform();
    }
    handlePlanButtonClick(planType) {
      this.router.transitionTo('plans.plan', planType, {
        queryParams: {
          isMonthly: true
        }
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "trialOptInPlans", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handlePlanButtonClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handlePlanButtonClick"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TrialOptInComponent);
});